function scrollToHashTarget(offset = 100, prefix = '') {
  const hash = window.location.hash;
  let offsetValue = parseInt(offset, 10);
  if (!hash) return;

  let target;

  // Special case: scroll to element with .theme-contact-form class if hash is #toform
  if (hash === '#toform') {
    offsetValue = 260;
    target = document.querySelector('.theme-contact-form');
  } else if (hash === '#to_form') {
    offsetValue = 60;
    target = document.querySelector('.theme-contact-form');
  } else if (hash === '#tolist') {
    const selectors = [
      '.properties-grid',
      '.properties-grid-location',
      '.properties-grid-product'
    ];

    // Find the first element that exists
    for (const selector of selectors) {
      target = document.querySelector(selector);
      if (target) break; // Stop at the first one that exists
    }
  } else {
    const targetId = prefix + hash.slice(1);
    target = document.getElementById(targetId);
  }

  if (target) {
    setTimeout(() => {
      const top = target.getBoundingClientRect().top + window.pageYOffset - offsetValue;
      window.scrollTo({
        top,
        behavior: 'smooth',
      });
    }, 100);
    if (hash === '#toform' || hash === '#tolist' || hash === '#to_form') {
      history.replaceState(null, '', window.location.pathname + window.location.search);
    }
  }
}

// Trigger on hash change
window.addEventListener('hashchange', () => scrollToHashTarget());
window.addEventListener('load', () => scrollToHashTarget());

function customScrollTo(selector, options = { behavior: "smooth", block: "start" }) {
  if (typeof selector !== "string" || !selector.trim()) {
    console.warn("customScrollTo: Invalid selector provided.");
    return;
  }

  const el = document.querySelector(selector);

  if (el) {
    el.scrollIntoView(options);
  } else {
    console.warn(`customScrollTo: No element found for selector "${selector}"`);
  }
}

window.customScrollTo = customScrollTo;
